var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaso3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58,
    d: "M49.1222 72.7451C63.1459 72.7451 74.5143 61.3726 74.5143 47.3439C74.5143 33.3152 63.1459 21.9427 49.1222 21.9427C35.0985 21.9427 23.7301 33.3152 23.7301 47.3439C23.7301 61.3726 35.0985 72.7451 49.1222 72.7451Z",
    fill: "url(#paint0_radial_1569_7306)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3055 51.4253C53.5022 49.7921 54.0382 47.7672 53.8062 45.7556C53.5743 43.7441 52.5915 41.8944 51.0545 40.5765C49.5174 39.2585 47.5395 38.5697 45.5165 38.6476C43.4934 38.7256 41.5744 39.5647 40.1433 40.9969C38.7122 42.4292 37.8747 44.3491 37.7982 46.3725C37.7217 48.3959 38.4119 50.3736 39.7307 51.9099C41.0495 53.4462 42.8997 54.4278 44.9111 54.6584C46.9225 54.8889 48.9468 54.3514 50.5789 53.1534H50.5777C50.6148 53.2028 50.6543 53.2498 50.6988 53.2955L55.457 58.0544C55.6888 58.2863 56.0031 58.4167 56.331 58.4168C56.6588 58.4169 56.9733 58.2868 57.2052 58.055C57.4371 57.8232 57.5675 57.5088 57.5676 57.1809C57.5677 56.853 57.4376 56.5385 57.2058 56.3066L52.4476 51.5477C52.4034 51.503 52.3559 51.4616 52.3055 51.4241V51.4253ZM52.6243 46.6739C52.6243 47.5666 52.4485 48.4507 52.1069 49.2755C51.7653 50.1003 51.2646 50.8498 50.6334 51.4811C50.0022 52.1124 49.2529 52.6131 48.4282 52.9548C47.6035 53.2964 46.7195 53.4723 45.8269 53.4723C44.9342 53.4723 44.0503 53.2964 43.2256 52.9548C42.4009 52.6131 41.6516 52.1124 41.0204 51.4811C40.3892 50.8498 39.8885 50.1003 39.5469 49.2755C39.2053 48.4507 39.0294 47.5666 39.0294 46.6739C39.0294 44.8708 39.7456 43.1416 41.0204 41.8667C42.2951 40.5917 44.0241 39.8754 45.8269 39.8754C47.6297 39.8754 49.3586 40.5917 50.6334 41.8667C51.9082 43.1416 52.6243 44.8708 52.6243 46.6739Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1569_7306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7264 51.109) scale(30.758 29.5382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D3DBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B9C6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9AACBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#758EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4B6B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345978"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaso3);
export default __webpack_public_path__ + "static/media/paso_3.beac9201893529c636373b2cf644ccd0.svg";
export { ForwardRef as ReactComponent };